"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.string.pad-end.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _getTime = require("@/assets/js/getTime");

var _SocketDispatcher = _interopRequireDefault(require("@/assets/js/SocketDispatcher"));

var _settings = require("@/model/settings");

var _keymap = require("@/assets/js/keymap.js");

var _bignumber = _interopRequireDefault(require("bignumber.js"));

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _vuex = require("vuex");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  mixins: [_commonMixin.default],
  props: {
    depthList: {
      type: Object,
      default: function _default() {
        return {
          a: [],
          b: []
        };
      }
    },
    swap_symbol_id: {
      type: [String, Number]
    },
    showTitle: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    marketList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    from_symbol: {
      type: [String, Number],
      default: function _default() {
        return "--";
      }
    },
    to_symbol: {
      type: [String, Number],
      default: function _default() {
        return "--";
      }
    }
  },
  data: function data() {
    return {
      systemCurrencyMaps: _keymap.systemCurrencyMaps,
      pageLoading: false,
      colorClass: "",
      price_precision: 2,
      precisionValue: "0.01",
      activeItem: 1,
      deptLength: 12,
      showBg: true,
      options: [],
      tradePair: {}
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var value, key;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getTradePairList();

            case 2:
              value = sessionStorage.getItem("dept-item-active");

              if (value) {
                _this.onItemClick(value);
              }

              for (key in _this.tradePair) {
                if (_this.tradePair[key].symbol_id == _this.swap_symbol_id) {
                  _this.price_precision = _this.tradePair[key].price_precision;
                }
              }

              _this.options = [{
                value: new _bignumber.default(1).div(new _bignumber.default(Math.pow(10, _this.price_precision))).toNumber()
              }, {
                value: 1 / Math.pow(10, _this.price_precision) * 10
              }, {
                value: 1 / Math.pow(10, _this.price_precision) * 100
              }];

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {},
  watch: {
    swap_symbol_id: function swap_symbol_id() {
      var _this2 = this;

      this.showBg = false;

      for (var key in this.tradePair) {
        if (this.tradePair[key].symbol_id == this.swap_symbol_id) {
          this.price_precision = this.tradePair[key].price_precision;
        }
      }

      setTimeout(function () {
        _this2.showBg = true;
      }, 300);
    },
    marketInfoShow: {
      handler: function handler(newValue, oldValue) {
        if (Number(newValue.last) - Number(oldValue.last) > 0) {
          this.colorClass = "green";
        } else if (Number(newValue.last) - Number(oldValue.last) < 0) {
          this.colorClass = "red";
        } else {
          this.colorClass = "";
        }
      },
      deep: true
    }
  },
  methods: {
    routeSplicing: _routeSplicing.default,
    getNowTime: _getTime.getNowTime,
    formatterValue: function formatterValue(value) {
      if (value == "--") return "--";
      var unit = "";
      var resultNum = "";
      var data = 0;

      if (value >= 1000000000) {
        unit = "B";
        data = (value / 1000000000).toFixed(2);
      } else if (value >= 1000000) {
        unit = "M";
        data = (value / 1000000).toFixed(2);
      } else if (value >= 1000) {
        unit = "K";
        data = (value / 1000).toFixed(2);
      } else {
        unit = "";
        data = value;
      }

      var num = data + "";

      if (!unit) {
        return data;
      }

      var length = 4;

      if (num.includes(".")) {
        if (num.length < 5) {
          resultNum = num.padEnd(length + 1, "0");
        } else {
          var numArray = num.split(".");

          if (numArray[0].length >= 4) {
            resultNum = num.substring(0, length);
          } else {
            resultNum = numArray[0] + "." + numArray[1].substring(0, length - numArray[0].length);
          }
        }
      } else {
        if (num.length < length) {
          resultNum = (num + ".").padEnd(length + 1, "0");
        } else {
          resultNum = num.substring(0, length);
        }
      }

      return resultNum + unit;
    },
    onMoreClick: function onMoreClick() {
      var routeUrl = this.$router.resolve({
        path: "/orderbook/",
        query: {
          type: "exchange",
          symbol: "".concat(this.from_symbol, "_").concat(this.to_symbol)
        }
      });
      window.location.href = routeUrl.href;
    },
    getTradePairList: function getTradePairList() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$apiGetStaticTa, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(55);

              case 2:
                _yield$apiGetStaticTa = _context2.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  _this3.tradePair = data;
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    ceilNum: function ceilNum(d) {
      var prex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      if (parseInt(d) == d) return d;
      var len = 1;
      var i = 0;

      while (parseInt(d) != d) {
        d = d * 10;
        len *= 10;
        i++;
      }

      var last = Math.abs(i <= prex ? 0 : d % Math.pow(10, i - prex));
      var d1 = d - last;

      if (last > 0) {
        d1 = d1 + Math.pow(10, i - prex);
      }

      d1 = d1 / len;
      return d1;
    },
    onPrecisionChange: function onPrecisionChange(value) {
      this.precisionValue = value;
    },
    onItemClick: function onItemClick(value) {
      this.activeItem = value;
      sessionStorage.setItem("dept-item-active", value);

      if (value == 2) {
        this.deptLength = 25;
      } else {
        this.deptLength = 12;
      }
    },
    onRowClick: function onRowClick(row) {
      _SocketDispatcher.default.dispatchEvent("onPriceClick", row);
    }
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language",
    systemCurrency: "user/currency"
  })), {}, {
    sellContentClass: function sellContentClass() {
      var className = "";

      if (this.activeItem == 1) {
        className = "";
      } else if (this.activeItem == 2) {
        className = "all";
      } else if (this.activeItem == 3) {
        className = "none";
      }

      return className;
    },
    buyContentClass: function buyContentClass() {
      var className = "";

      if (this.activeItem == 1) {
        className = "";
      } else if (this.activeItem == 2) {
        className = "none";
      } else if (this.activeItem == 3) {
        className = "all";
      }

      return className;
    },
    from_symbol_show: function from_symbol_show() {
      return this.from_symbol.toUpperCase() || "--";
    },
    to_symbol_show: function to_symbol_show() {
      return this.to_symbol.toUpperCase() || "--";
    },
    loading: function loading() {
      var val = 1;

      if (this.depthList instanceof Array && this.depthList.a[0][0] == "--") {
        val = 1;
      } else {
        val = 0;
      }

      return val;
    },
    bigBuy: function bigBuy() {
      var tempList = this.depthList.a.slice(0, this.deptLength);
      var temp = [];

      if (this.depthList.a.length > 0) {
        temp = Number(this.depthList.a[0][1]);

        for (var i = 0; i < tempList.length - 1; i++) {
          temp = temp < Number(tempList[i + 1][1]) ? Number(tempList[i + 1][1]) : temp;
        }
      }

      return temp;
    },
    bigSell: function bigSell() {
      var tempList = this.depthList.b.slice(0, this.deptLength);
      var temp = [];

      if (this.depthList.b.length > 0) {
        Number(this.depthList.b[0][1]);

        for (var i = 0; i < tempList.length - 1; i++) {
          temp = temp < Number(tempList[i + 1][1]) ? Number(tempList[i + 1][1]) : temp;
        }
      }

      return temp;
    },
    totleBuy: function totleBuy() {
      var temp = 0;
      this.depthList.a.slice(0, this.deptLength).forEach(function (ele) {
        temp += Number(ele[1]);
      });
      return temp;
    },
    totleSell: function totleSell() {
      var temp = 0;
      this.depthList.b.slice(0, this.deptLength).forEach(function (ele) {
        temp += Number(ele[1]);
      });
      return temp;
    },
    // a卖  b买
    showListSell: function showListSell() {
      var array = new Array(this.deptLength);

      if (this.depthList.a.length < this.deptLength) {
        array = this.depthList.a.slice(0, this.deptLength);
      } else {
        array = this.depthList.a.slice(0, this.deptLength);
      } // 翻转原数组


      for (var i = 0; i < array.length / 2; i++) {
        var temp = array[i];
        array[i] = array[array.length - 1 - i];
        array[array.length - 1 - i] = temp;
      }

      var tempLength = array.length;

      if (array.length < this.deptLength) {
        for (var index = 0; index < this.deptLength - tempLength; index++) {
          array.unshift([,]);
        }
      }

      return array;
    },
    showListBuy: function showListBuy() {
      return this.depthList.b;
    },
    marketInfoShow: function marketInfoShow() {
      var _this4 = this;

      var marketInfo = {
        last: "--",
        currency: {
          cny: "--"
        }
      };
      this.marketList.forEach(function (ele) {
        if (ele.symbol_id == _this4.swap_symbol_id) {
          marketInfo = ele;
        }
      });
      return marketInfo;
    },
    className: function className() {
      var className = "";

      if (!this.marketInfoShow.price_change_percent) {
        className = "";
      } else if (this.marketInfoShow.price_change_percent > 0) {
        className = "green";
      } else if (this.marketInfoShow.price_change_percent < 0) {
        className = "red";
      }

      return className;
    }
  })
};
exports.default = _default2;